import { Cropper } from "react-cropper";
import styled, { css } from "styled-components";

export const CoverImage = styled.div<{ url?: string }>`
    position: relative;
    max-width: 600px;
    border-radius: 15px;
    background: ${({ url }) => (url ? `url(${url})` : "aliceblue")};
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: 16px;
    margin-bottom: 50px;
`;

export const CoverImageUpload = styled.label`
    display: flex;
    opacity: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 15px;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
`;

export const EditText = styled.span``;

export const ProfilePicture = styled.label<{ url: string }>`
    border: 2px solid #ddd;
    position: absolute;
    left: 20px;
    bottom: -50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: ${({ url }) => (url ? `#fff url(${url})` : "crimson")};
    background-blend-mode: multiply;
    background-position: center;
    background-size: contain;
    cursor: pointer;

    span {
        display: none;
    }

    &:hover {
        span {
            display: block;
        }
        box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5);
    }
`;

export const FileInput = styled.input`
    display: none;
`;

export const CropImage = styled(Cropper)<{ isProfile: boolean }>`
    max-width: 80vw;
    max-height: 400px;

    ${({ isProfile }) =>
        isProfile &&
        css`
            .cropper-view-box {
                box-shadow: 0 0 0 1px #39f;
                border-radius: 50%;
                outline: 0;
            }
            .cropper-face {
                background-color: inherit !important;
            }
            .cropper-view-box {
                outline: inherit !important;
            }
        `}
`;
